export default "__VITE_ASSET__Df6Mc6hK__"